const localeAddressFieldOrder = {
    en: [
        "address1",
        "address2",
        "address3",
        "address4",
        "town",
        "state",
        "postcode",
        "country",
    ],
    ja: [
        "postcode",
        "state",
        "town",
        "address1",
        "address2",
        "address3",
        "address4",
        "country",
    ],
};

export const Address = ({
    address1,
    address2,
    address3,
    address4,
    town,
    state,
    postcode,
    country,
    render,
    locale,
}) => {
    //Map the address fields to the input fields
    const mappedFields = [
        {
            id: "address1",
            ...address1,
        },
        {
            id: "address2",
            ...address2,
        },
        {
            id: "address3",
            ...address3,
        },
        {
            id: "address4",
            ...address4,
        },
        {
            id: "town",
            ...town,
        },
        {
            id: "state",
            ...state,
        },
        {
            id: "postcode",
            ...postcode,
        },
        {
            id: "country",
            ...country,
        },
    ];

    //Get the order of the fields based on the locale
    let addressFields = localeAddressFieldOrder[locale || "en"];

    //If the locale is not found, default to English order
    if (!addressFields) {
        addressFields = localeAddressFieldOrder["en"];
    }

    //Map the address fields to the input fields
    const remappedFields = addressFields
        .map((fieldId) => {
            const field = mappedFields.find((field) => field.id === fieldId);
            //Return the field with the same id as the fieldId, but only
            //return the field if it exists and has more than just the id
            if (!field || Object.keys(field).length <= 1) {
                return null;
            }
            return {
                ...field,
            };
        })
        //Filter out any null fields as these were not passed in
        //allows for areas that don't need all the possible fields
        .filter((field) => field);

    return remappedFields.map((field, index) => {
        //Render one of the children for each field, with the field as props
        return render(
            { ...field, key: field.id },
            index,
            remappedFields.length
        );
    });
};
